// 🔥 GLOBAL MUTABLE CONFIG

export let CLUB_ID = "racket-riot-club";

export let APP_CLUB_ID = "racket-riot-club";

export let CLUB_NAME = "Racket Riot Club";

export let THEME_COLOR = "#591094";

export let BOTTOM_NAV_HEIGHT = 56;

export let LEVELS = [
    { value: 7, label: "Advanced", color: "#f8d7da" },
    { value: 6, label: "High Int", color: "#fce8b2" },
    { value: 5, label: "Intermediate", color: "#fff8b0" },
    { value: 4, label: "Low Int", color: "#d4f4dd" },
    { value: 3, label: "High Beginner", color: "#d1faff" },
    { value: 2, label: "Beginner", color: "#c4dcf7" },
    { value: 1, label: "Novice", color: "#e6d4f9" },
];

export let LEVELS_MAP = Object.fromEntries(
    LEVELS.map(item => [item.value, item.label])
);

// 🔥 UPDATE CONFIG FROM FIRESTORE
export const updateClubConfig = (settings) => {

    CLUB_ID = settings.clubId || CLUB_ID;

    APP_CLUB_ID = settings.appClubId || APP_CLUB_ID;

    CLUB_NAME = settings.clubName || CLUB_NAME;

    THEME_COLOR = settings.themeColor || THEME_COLOR;

    BOTTOM_NAV_HEIGHT =
        settings.bottomNavHeight || BOTTOM_NAV_HEIGHT;

    LEVELS = settings.levels || LEVELS;

    LEVELS_MAP = Object.fromEntries(
        LEVELS.map(item => [item.value, item.label])
    );
};

export const levelColor = (level) => {
    return (
        LEVELS.find(l => l.value === level)?.color
        || "#cccccc"
    );
};